export default __webpack_public_path__ + "static/media/004-A-fournisseureau.ad5000b1.svg";